(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/analytics/assets/javascripts/trackanalytics.js') >= 0) return;  svs.modules.push('/components/core/analytics/assets/javascripts/trackanalytics.js');
"use strict";


(function (svs, _svs$core$target) {
  'use strict';

  svs.core = svs.core || {};
  svs.core.analytics = svs.core.analytics || {};
  svs.core.analytics.adl = svs.core.analytics.adl || {};
  const log = new svs.core.log.Logger('svs.core.analytics');

  window.dataLayerPush({
    event: 'OneTrustGroups',
    optanonActiveGroups: svs.core.analytics.data.svsanalytics.optanonActiveGroups
  });
  window.dataLayerPush(svs.core.analytics.data.svsanalytics.user);
  window.dataLayerPush({
    event: 'pageview',
    page: {
      pageInfo: {
        pageID: document.location.pathname,
        pageName: document.title,
        destinationURL: document.location.pathname + document.location.search,
        sysEnv: svs.core.analytics.data.svsanalytics.formFactor
      },
      webPropertyId: svs.core.analytics.data.svsanalytics.config.account
    }
  });
  let analytics = false;
  let personalized = false;
  if (svs.core.config.data.svsconfig.oneTrust.enabled) {
    const consent = svs.core.analytics.data.svsanalytics.optanonConsent;
    analytics = (consent === null || consent === void 0 ? void 0 : consent.performance) || false;
    personalized = (consent === null || consent === void 0 ? void 0 : consent.personalization) || false;
  }

  svs.core.analytics.adl.consent = {
    analyticsBrowser: analytics,
    personalizedBrowser: personalized,
    QualtricsOk: svs.core.analytics.data.svsanalytics.qualtrics,
    surveyOkCaretech: svs.core.analytics.data.svsanalytics.surveyOkCaretech
  };
  svs.core.analytics.adl.user = {
    loggedIn: svs.core.analytics.data.svsanalytics.adobeUser.loggedIn || 'no',
    role: svs.core.analytics.data.svsanalytics.adobeUser.role || '',
    userId: svs.core.analytics.data.svsanalytics.adobeUser.userId || '',
    devId: svs.core.analytics.data.svsanalytics.adobeUser.devId || '',
    nativeData: svs.core.analytics.data.svsanalytics.adobeUser.nativeData || ''
  };
  svs.core.analytics.adl.site = {
    name: svs.core.analytics.data.svsanalytics.adobeLaunch.site,
    formFactor: svs.core.analytics.data.svsanalytics.formFactor,
    suite: svs.core.analytics.data.svsanalytics.adobeLaunch.suite,
    hostname: location.host
  };
  svs.core.analytics.adl.page = {
    name: document.location.pathname.substring(1).replace(/\//g, ':'),
    url: location.pathname + location.search
  };
  window.adobeDataLayer.adlPush('pageView', {
    site: svs.core.analytics.adl.site,
    consent: svs.core.analytics.adl.consent,
    user: svs.core.analytics.adl.user,
    page: svs.core.analytics.adl.page
  });
  window.adobeDataLayer.adlPush('user', {
    site: svs.core.analytics.adl.site,
    consent: svs.core.analytics.adl.consent,
    user: svs.core.analytics.adl.user,
    page: svs.core.analytics.adl.page
  });
  if ((_svs$core$target = svs.core.target) !== null && _svs$core$target !== void 0 && _svs$core$target.data) {
    var _svs$core$target$data;
    const targetPayloadMsg = new svs.core.log.Message(svs.core.log.MessageType.targetPayload);
    targetPayloadMsg.pe = svs.core.target.data.viewPayload.pe;
    targetPayloadMsg.tnta = svs.core.target.data.viewPayload.tnta;
    if ((_svs$core$target$data = svs.core.target.data) !== null && _svs$core$target$data !== void 0 && _svs$core$target$data.payload) {
      window.adobeDataLayer.adlPush('targetPayloadView', {
        site: svs.core.analytics.adl.site,
        consent: svs.core.analytics.adl.consent,
        user: svs.core.analytics.adl.user,
        page: svs.core.analytics.adl.page,
        payload: svs.core.target.data.payload
      });
    }
    svs.core.log.track('svs.core.analytics', targetPayloadMsg);
  }
  const metric = new svs.core.log.Message(svs.core.log.MessageType.pageview);
  svs.core.log.track('svs.core.analytics', metric);
  function sleep(delay) {
    return new Promise(resolve => {
      setTimeout(resolve, delay);
    });
  }

  async function trackAdobeUser(declaredId) {
    if (!declaredId) {
      log.warn("svs.core.analytics.trackAdobeUser was called without a declaredId");
      return;
    }
    const adobeUser = {
      loggedIn: 'yes',
      role: 'Player',
      userId: declaredId
    };
    svs.core.analytics.adl.user = {
      loggedIn: adobeUser.loggedIn || 'no',
      role: adobeUser.role || '',
      userId: adobeUser.userId || '',
      devId: svs.core.analytics.data.svsanalytics.adobeUser.devId || '',
      nativeData: svs.core.analytics.data.svsanalytics.adobeUser.nativeData || ''
    };
    window.adobeDataLayer.adlPush('user', {
      site: svs.core.analytics.adl.site,
      consent: svs.core.analytics.adl.consent,
      user: svs.core.analytics.adl.user,
      page: svs.core.analytics.adl.page
    });

    await sleep(100);
  }
  svs.core.analytics.trackAdobeUser = trackAdobeUser;
  function getPerformanceTiming() {
    const perf = window.performance || window.webkitPerformance;
    if (!perf) {
      return null;
    }
    if (perf.getEntriesByType) {
      const navigation = perf.getEntriesByType('navigation')[0];
      if (navigation) {
        return navigation;
      }
    }
    return perf.timing || null;
  }
  function testPerformance(measurements) {
    const perf = getPerformanceTiming();
    if (!perf) {
      return;
    }
    const navigationStart = perf.navigationStart || perf.startTime || perf.fetchStart || 0;
    let totalPageLoadTime = null;
    if (Number.isFinite(perf.loadEventEnd)) {
      totalPageLoadTime = perf.loadEventEnd - navigationStart;
    } else if (Number.isFinite(perf.loadEventStart)) {
      totalPageLoadTime = perf.loadEventStart - navigationStart;
    }
    let serverResponseTime = null;
    if (Number.isFinite(perf.responseStart) && Number.isFinite(perf.requestStart) && perf.responseStart >= perf.requestStart) {
      serverResponseTime = perf.responseStart - perf.requestStart;
    }
    let pageDownloadTime = null;
    if (Number.isFinite(perf.responseEnd) && Number.isFinite(perf.responseStart) && perf.responseEnd >= perf.responseStart) {
      pageDownloadTime = perf.responseEnd - perf.responseStart;
    }
    let pageInteractive = null;
    if (Number.isFinite(perf.domInteractive)) {
      pageInteractive = perf.domInteractive - navigationStart;
    }
    if (Number.isFinite(totalPageLoadTime) && totalPageLoadTime >= 0) {
      measurements.totalPageLoadTime = totalPageLoadTime;
    }
    if (Number.isFinite(serverResponseTime) && serverResponseTime >= 0) {
      measurements.serverResponseTime = serverResponseTime;
    }
    if (Number.isFinite(pageDownloadTime) && pageDownloadTime >= 0) {
      measurements.pageDownloadTime = pageDownloadTime;
    }
    if (Number.isFinite(pageInteractive) && pageInteractive >= 0) {
      measurements.pageInteractive = pageInteractive;
    }
  }
  function pageTimingTest() {
    let sendLog = true;
    const perf = getPerformanceTiming();
    if (!perf) {
      return;
    }
    let loadEventEnd = 0;
    if (Number.isFinite(perf.loadEventEnd)) {
      loadEventEnd = perf.loadEventEnd;
    } else if (Number.isFinite(perf.loadEventStart)) {
      loadEventEnd = perf.loadEventStart;
    }
    if (loadEventEnd < 1) {
      setTimeout(() => {
        pageTimingTest();
      }, 200);
      return;
    }

    const sampleRate = parseInt(svs.core.analytics.data.svsanalytics.config.siteSpeedSampleRate, 10);
    const sampleNumber = Math.floor(Math.random() * (100 + 1));
    if (sampleNumber <= sampleRate) {
      const logdata = {};
      testPerformance(logdata);
      if (!$.isEmptyObject(logdata)) {
        $.each(logdata, (key, value) => {
          if (!parseInt(value, 10)) {
            sendLog = false;
          }
        });
        if (sendLog) {
          const timings = new svs.core.log.Message(svs.core.log.MessageType.timing);
          timings.totalPageLoadTime = logdata.totalPageLoadTime;
          timings.serverResponseTime = logdata.serverResponseTime;
          timings.pageDownloadTime = logdata.pageDownloadTime;
          timings.interactivePage = logdata.pageInteractive;
          svs.core.log.track('svs.core.analytics', timings);
        }
      }
    }
  }
  const pageTimingsTest = pageTimingTest;
  svs.core.analytics.timingTest = pageTimingsTest;
  svs.core.analytics.pageTimingTest = pageTimingsTest;
  $(document).ready(() => {
    pageTimingTest();
  });
})(svs);

 })(window);